/* SST global scripts — shared behaviour used by more than one section.
   Section-only behaviour lives in assets/sst-<section>.js. */

window.SST = window.SST || {};

/* Cart count: every [data-sst-cart-count] shows the live item count. */
SST.refreshCartCount = async function () {
  try {
    const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
    document.querySelectorAll('[data-sst-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  } catch (e) {
    /* count stays stale; the cart page is still correct */
  }
};

/* Adds a variant; when the cart type is "drawer", re-renders Dawn's <cart-drawer> and opens it. */
SST.addToCart = async function (variantId, quantity = 1) {
  const drawer = document.querySelector('cart-drawer');
  const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity }],
      ...(drawer && { sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
    }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
  drawer?.classList.remove('is-empty');
  drawer?.renderContents(data);
  SST.refreshCartCount();
  return data;
};

/* Header cart icon opens Dawn's <cart-drawer> when enabled; otherwise it follows the link. */
document.addEventListener('click', (e) => {
  const drawer = document.querySelector('cart-drawer');
  const link = e.target.closest('[data-sst-cart-link]');
  if (!drawer || !link) return;
  e.preventDefault();
  drawer.open(link);
});

/* Keep the count in sync when Dawn's own forms (product page) update the cart. */
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, SST.refreshCartCount);
  }
});

/* <sst-carousel>: prev/next buttons page a horizontal .sst-scroller.
   Markup: [data-carousel-track], [data-carousel-prev], [data-carousel-next]. */
if (!customElements.get('sst-carousel')) {
  customElements.define(
    'sst-carousel',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.go(-1));
        this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.go(1));
      }

      go(dir) {
        const item = this.track.firstElementChild;
        const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : 340;
        this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
    }
  );
}

/* <sst-video>: click [data-video-play] to swap the poster for the <template> video.
   Loading the video only on demand keeps it off the critical path. */
if (!customElements.get('sst-video')) {
  customElements.define(
    'sst-video',
    class extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-video-play]')?.addEventListener('click', (e) => {
          e.preventDefault();
          this.play();
        });
      }

      play() {
        if (this.video) return this.video.paused ? this.video.play() : this.video.pause();
        const template = this.querySelector('template');
        if (!template) return;
        const target = this.querySelector('[data-video-target]') || this;
        target.appendChild(template.content.cloneNode(true));
        this.video = target.querySelector('video');
        this.classList.add('is-playing');
        this.video?.play();
      }
    }
  );
}
